import { useEffect, useRef } from "react";
import { CalendarDays, FolderOpen, UserRound, Wallet } from "lucide-react";

const GROUP_ICONS = {
  profile: UserRound,
  time: CalendarDays,
  pay: Wallet,
  records: FolderOpen,
};

export default function EmployeeProfileTabNav({ groups, activeTab, onChange }) {
  const subRef = useRef(null);
  const activeGroup = groups.find((g) => g.tabs.some((t) => t.id === activeTab)) || groups[0];

  useEffect(() => {
    const row = subRef.current;
    const el = row?.querySelector(`[data-tab-id="${activeTab}"]`);
    if (el && row) {
      row.scrollTo({ left: el.offsetLeft - row.clientWidth / 2 + el.clientWidth / 2, behavior: "smooth" });
    }
  }, [activeTab]);

  if (!activeGroup) return null;

  return (
    <nav className="ep-tabs-wrap" aria-label="Employee profile sections">
      <div className="ep-group-tabs" role="tablist">
        {groups.map((group) => {
          const Icon = GROUP_ICONS[group.id] || UserRound;
          const active = group.id === activeGroup.id;
          return (
            <button
              key={group.id}
              type="button"
              role="tab"
              aria-selected={active}
              className={`ep-group-tab${active ? " active" : ""}`}
              onClick={() => {
                if (!active) onChange(group.tabs[0].id);
              }}
            >
              <Icon size={18} strokeWidth={2} aria-hidden />
              <span>{group.label}</span>
            </button>
          );
        })}
      </div>
      <div className="ep-tabs" ref={subRef} role="tablist">
        {activeGroup.tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            data-tab-id={tab.id}
            className={`ep-tab${activeTab === tab.id ? " active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </nav>
  );
}
